module.exports = __webpack_public_path__ + "static/media/manage_your_business.47d57f3b.webp";